import { defaultColumns as defaultColumnsFleet } from "../../fleet/VehicleListTable/columns";

export const ravDefaultColumns = defaultColumnsFleet.map((c) => {
  return c;
});
